import React from 'react';

import {
  CarouselProvider,
  Slider,
  ButtonNext,
  ButtonPrev,
  Counter,
  Dots,
} from '../UI/Carousel';
import Icon from '../UI/Icon/Icon.js';
import * as styles from './TestimonialCarousel.module.scss';

const TestimonialCarousel = ({ children, isWhiteOut }) => {
  return (
    <div className={styles.container}>
      <CarouselProvider totalSlides={React.Children.count(children)}>
        <div className={styles.controls}>
          <ButtonPrev className={styles.btnPrev}>
            <Icon name="chevron-left" />
          </ButtonPrev>

          <Counter className={styles.count} />

          <ButtonNext className={styles.btnNext}>
            <Icon name="chevron-right" />
          </ButtonNext>
        </div>

        <div className={styles.slider}>
          <Slider height="auto" transition="fade">
            {children}
          </Slider>
        </div>

        <Dots isWhiteOut={isWhiteOut} />
      </CarouselProvider>
    </div>
  );
};

export default TestimonialCarousel;
